export const companyHistoryMappings = {
  createdAt: 'Created On',
  createdBy: 'Created By',
  lastUpdatedAt: 'Updated On',
  lastUpdatedBy: 'Updated By'
};

export const defaultColumnMappings = {
  name: 'Name',
  preview: '',
  database: 'Database',
  address: 'Address',
  website: 'Website',
  lastContacted: 'Last Contacted'
};

export const excludedColumns = [
  'preview',
  'database',
  'address',
  'website',
  'lastContacted'
];

export const sortableColumnTypes = {
  name: "alpha",
  createdAt: "amount",
  createdBy: "alpha",
  lastUpdatedAt: "amount",
  lastUpdatedBy: "alpha",
};

export const companyInformationMappings = {
  historyInformation: {
    title: "History",
    mappings: companyHistoryMappings,
    key: 'history-mappings'
  }
};
